var _defs, _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelationshipHealingAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F766E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orb",
    x1: 246,
    y1: 240,
    x2: 932,
    y2: 684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F0ABFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EEAD4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: 0,
    y: 0,
    width: 1200,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 200,
    r: 110,
    fill: "#C4B5FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 220,
    r: 130,
    fill: "#7DD3FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 720,
    r: 140,
    fill: "#67E8F9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 720,
    r: 145,
    fill: "#A7F3D0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#orb)",
    strokeWidth: 6,
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 470,
    rx: 280,
    ry: 180
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 470,
    rx: 210,
    ry: 280,
    transform: "rotate(-18 600 470)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 470,
    rx: 210,
    ry: 280,
    transform: "rotate(18 600 470)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#E0F2FE",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 470,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 290,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 650,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 404,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 404,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 536,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 536,
    r: 7
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#CCFBF1",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 520C370 420 430 360 540 335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 520C830 420 770 360 660 335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 680C440 610 500 575 560 545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 680C760 610 700 575 640 545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationshipHealingAbout);
export default __webpack_public_path__ + "static/media/relationship-healing-about.027e71534ad5ed9dc257f9c7d92be23c.svg";
export { ForwardRef as ReactComponent };